import React from "react";

interface ResizableTruncatableCellProps {
  text: string;
  className?: string;
  renderText?: (text: string) => React.ReactNode;
  placeholder?: React.ReactNode;
  onClick?: () => void;
}

const ResizableTruncatableCell: React.FC<ResizableTruncatableCellProps> = ({
  text,
  className = "",
  renderText,
  placeholder = null,
  onClick,
}) => {
  const content = text ? (renderText ? renderText(text) : text) : placeholder;

  return (
    <div className={`relative ${className}`}>
      <div
        className="overflow-hidden text-ellipsis  min-w-0"
        onClick={onClick}
        title={text}
      >
        {content}
      </div>
    </div>
  );
};

export default ResizableTruncatableCell;
